import { render, staticRenderFns } from "./activitycategorydetails.vue?vue&type=template&id=3df73b2b&scoped=true"
import script from "./activitycategorydetails.vue?vue&type=script&lang=js"
export * from "./activitycategorydetails.vue?vue&type=script&lang=js"
import style0 from "./activitycategorydetails.vue?vue&type=style&index=0&id=3df73b2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df73b2b",
  null
  
)

export default component.exports